import type { ComponentProps } from 'react';
import { useFlag } from '@/features/unleash';
import { FairValueTooltip } from './FairValueTooltip';

type FairValueTooltipProps = ComponentProps<typeof FairValueTooltip>;

export const FlaggedFairValueTooltip = (props: FairValueTooltipProps) => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-fair-value-tooltip',
  });

  if (flagsReady && enabled) {
    return <FairValueTooltip {...props} />;
  }

  return props.children;
};
